import React from 'react'
import { Link } from 'gatsby'

import * as styles from './logo.module.scss'

export default ({ block, scrollToTop }) => (
  <section className={styles.section}>
    <Link to='/' onClick={scrollToTop}><img src={block.logo} className={styles.logo} /></Link>
  </section>
)